import { switchToMonthlyGetPolicy, switchToMonthlyApplyBusinessRules } from '@/constants/forms-api.const';
import { IServiceResponse } from '@/interfaces/entities';
import { RequestServices as _http } from '../common/request.services';
import { InsuranceProduct } from '@/interfaces/entities/insurance-product.interface';
import {
  ApplyRulesResponseOfSwitchToMonthlyViewModel,
  ApplyRulesRequestOfSwitchToMonthlyUpdateModel,
} from '@/interfaces/forms/switch-to-monthly/switch-to-monthly.interface';

export const SwitchToMonthlyService = {
  /**
   * Get Policy
   *
   * @param quoteSessionId
   */
  getPolicy(quoteSessionId: string): Promise<IServiceResponse<InsuranceProduct>> {
    return _http.HttpGet(switchToMonthlyGetPolicy.replace('{0}', quoteSessionId));
  },

  /**
   * Apply Business Rules
   *
   * @param request
   */
  applyBusinessRules(
    request: ApplyRulesRequestOfSwitchToMonthlyUpdateModel
  ): Promise<IServiceResponse<ApplyRulesResponseOfSwitchToMonthlyViewModel>> {
    return _http.HttpPost(switchToMonthlyApplyBusinessRules, request);
  },
};
